import QISignTheme from '../../../interfaces/Theme';
import Header from '../Header';
import Section from '../Section';
import Callout from '../Callout';
import Checkbox from '../Checkbox';
import DataList from '../DataList';

declare type BackendComponent = {
    component: string;
    [key: string]: any;
}

declare type ComponentRendererProps = {
    components: BackendComponent[];
    clientThemeSettings: QISignTheme;
    checkboxState?: Record<number, boolean>;
    onCheckboxChange?: (index: number, checked: boolean) => void;
}

export default function ComponentRenderer({ components, clientThemeSettings, checkboxState, onCheckboxChange }: ComponentRendererProps) {
    return (
        <>
            {components.map((item, index) => {
                if (item.component === 'header') {
                    return <Header key={index} title={item.title} description={item.description} icon={item.icon} clientThemeSettings={clientThemeSettings} />
                }
                if (item.component === 'section') {
                    return <Section key={index} title={item.title} description={item.description} type={item.type} />
                }
                if (item.component === 'callout') {
                    return <Callout key={index} label={item.label} title={item.title} description={item.description} type={item.type} />
                }
                if (item.component === 'checkbox') {
                    return (
                        <Checkbox
                            key={index}
                            title={item.title}
                            description={item.description}
                            required={item.required}
                            checked={checkboxState?.[index] ?? false}
                            onChange={(checked) => onCheckboxChange?.(index, checked)}
                        />
                    )
                }
                if (item.component === 'data_list') {
                    return <DataList key={index} label={item.label} items={item.items} />
                }
                return null;
            })}
        </>
    )
}
